const ajuda = {
  // ─── Campanha ────────────────────────────
  nome_campanha: {
    texto: 'Nome interno para identificar esta campanha. Só você verá esse nome.',
    exemplo: 'Promoção de Dezembro, Follow-up Clientes VIP'
  },
  instancia_whatsapp: {
    texto: 'O número de WhatsApp que vai enviar as mensagens. Configure em Menu → WhatsApp.',
    exemplo: 'chip-vendas-01, whatsapp-principal'
  },
  mensagem: {
    texto: 'Texto que será enviado para cada contato. Use {nome} para personalizar com o nome da pessoa.',
    exemplo: 'Olá {nome}, temos uma oferta especial para você!'
  },
  intervalo_min: {
    texto: 'Tempo mínimo de espera entre cada mensagem. O máximo é automático (mínimo + 8s) e o sistema sorteia um valor aleatório dentro dessa faixa para simular comportamento humano. Mínimo aceito: 8 segundos.',
    exemplo: '8 a 12 segundos (recomendado)'
  },
  hora_inicio: {
    texto: 'Horário em que os disparos começam. Fora desse horário, os envios são pausados automaticamente.',
    exemplo: '08:00 (início do expediente)'
  },
  hora_fim: {
    texto: 'Horário em que os disparos param. No dia seguinte, retomam do ponto onde pararam.',
    exemplo: '18:00 (fim do expediente)'
  },
  data_inicio: {
    texto: 'Data em que a campanha começa a ser processada. Use hoje para disparar imediatamente.',
    exemplo: 'Hoje, ou uma data futura para agendar'
  },
  midia: {
    texto: 'Imagem, vídeo, áudio ou documento enviado junto com a mensagem. Aumenta o engajamento.',
    exemplo: 'Foto do produto, vídeo de demonstração, PDF do catálogo'
  },
  tipo_envio: {
    texto: 'Escolha o canal de envio. WhatsApp é o padrão. Email requer o addon de email contratado.',
    exemplo: 'WhatsApp para mensagens diretas, Email para comunicações formais'
  },

  // ─── Contatos ────────────────────────────
  telefone: {
    texto: 'Número com código do país + DDD + número, sem espaços ou símbolos. O sistema normaliza automaticamente.',
    exemplo: '5511999999999 (55=Brasil, 11=SP, 9 dígitos)'
  },
  csv_formato: {
    texto: 'Arquivo CSV com colunas separadas por vírgula ou ponto-e-vírgula. Apenas telefone é obrigatório.',
    exemplo: 'nome,telefone,email — uma linha por contato'
  },
  contato_nome: {
    texto: 'Nome do contato para personalização. Será substituído onde houver {nome} na mensagem.',
    exemplo: 'João Silva, Maria Souza'
  },
  contato_email: {
    texto: 'Email do contato. Usado quando o canal de envio for email (requer addon).',
    exemplo: 'joao@email.com'
  },

  // ─── Grupos ──────────────────────────────
  grupo_nome: {
    texto: 'Nome para identificar este grupo de contatos. Use nomes descritivos para facilitar a seleção nas campanhas.',
    exemplo: 'Leads quentes, Clientes VIP, Novos cadastros'
  },
  grupo_descricao: {
    texto: 'Descrição opcional para lembrar o propósito deste grupo.',
    exemplo: 'Clientes que compraram nos últimos 30 dias'
  },
  grupo_tamanho: {
    texto: 'Quantidade de contatos por grupo automático. Grupos menores reduzem risco de bloqueio pelo WhatsApp.',
    exemplo: '20 contatos por grupo (recomendado)'
  },
  grupo_prefixo: {
    texto: 'Texto que aparece antes do número do grupo gerado automaticamente.',
    exemplo: 'Lote, Grupo, Turma'
  },

  // ─── WhatsApp ────────────────────────────
  instancia_nome: {
    texto: 'Nome único para identificar este número de WhatsApp no sistema. Use algo descritivo e sem espaços.',
    exemplo: 'chip-vendas, whatsapp-suporte, numero-principal'
  },
  whatsapp_qrcode: {
    texto: 'Escaneie o QR Code com o WhatsApp do celular: Configurações → Aparelhos conectados → Conectar aparelho.',
    exemplo: 'O QR Code atualiza automaticamente a cada 20 segundos'
  },
  whatsapp_sincronizar: {
    texto: 'Importa os contatos salvos no WhatsApp para a plataforma. Contatos duplicados são ignorados.',
    exemplo: 'Útil para importar contatos já existentes no celular'
  },

  // ─── Configurações ───────────────────────
  smtp_host: {
    texto: 'Endereço do servidor SMTP do seu provedor de email. Encontre nas configurações da sua conta de email.',
    exemplo: 'smtp.gmail.com, smtp.office365.com, smtp.hostinger.com'
  },
  smtp_port: {
    texto: 'Porta de conexão com o servidor SMTP. A mais comum é 587 (TLS). Use 465 para SSL.',
    exemplo: '587 (TLS — recomendado) ou 465 (SSL)'
  },
  smtp_user: {
    texto: 'Seu email completo ou nome de usuário no servidor SMTP.',
    exemplo: 'seu@gmail.com ou seu@empresa.com'
  },
  smtp_pass: {
    texto: 'Senha do email ou senha de app. No Gmail, use Senha de App (não a senha normal).',
    exemplo: 'Para Gmail: Conta Google → Segurança → Senhas de app'
  },
  smtp_from: {
    texto: 'Email que aparecerá como remetente das mensagens enviadas.',
    exemplo: 'contato@suaempresa.com, noreply@suaempresa.com'
  },
  openai_key: {
    texto: 'Chave de acesso à IA que gera variações automáticas das mensagens. Obtenha em platform.openai.com.',
    exemplo: 'sk-...'
  },
  whatsapp_apikey: {
    texto: 'Chave de acesso à Evolution API. Configurada durante a instalação do sistema.',
    exemplo: '429683C4C977415CAAFCCE10F7D57E11'
  },

  // ─── Envios ──────────────────────────────
  envios_campanha: {
    texto: 'Selecione uma campanha para ver o histórico de envios. Os dados atualizam automaticamente a cada 10 segundos.',
    exemplo: 'Campanhas finalizadas mostram todos os envios realizados'
  },

  // ─── Anti-ban ────────────────────────────
  blacklist: {
    texto: 'Contatos que pediram para não receber mais mensagens. São removidos automaticamente de todas as campanhas futuras. Você pode retirar um contato da blacklist clicando em "×".',
    exemplo: 'Contatos que responderam STOP, PARAR, CANCELAR ou SAIR'
  },
  cap_diario: {
    texto: 'Limite de mensagens enviadas por dia por este chip. O limite cresce automaticamente com o tempo para proteger o número de bloqueios. Chips novos têm limite baixo que aumenta conforme ganham confiança do WhatsApp.',
    exemplo: 'Semana 1: 50/dia → Semana 2: 100/dia → Semana 3: 200/dia → Após 21 dias: 500/dia'
  },
  warmup: {
    texto: 'Aquecimento gradual do chip. Números novos que disparam alto volume imediatamente são bloqueados pelo WhatsApp. O sistema limita automaticamente e aumenta o volume dia a dia.',
    exemplo: 'Um chip de 30+ dias de uso já está "aquecido" e pode enviar até 500 mensagens/dia'
  },
};

export default ajuda;